import {
  ADD_ORG,
  CLEAR_ORGANISATION_ERROR,
  CLOSE_CREATE_ORGANISATION_MODAL,
  CREATE_ORGANISATION_ERROR,
  CREATE_ORGANISATION_PENDING,
  CREATE_ORGANISATION_SUCCESS,
  OPEN_CREATE_ORGANISATION_MODAL,
  ORGANISATION_LIST_ERROR,
  SET_INITIAL_STATE,
  SET_ORGANISATIONS_LIST,
  SET_ORGANISATIONS_LIST_ASYNC,
  SET_ORGANISATIONS_PENDING,
  SET_PAGE_SIZE_GLOBAL,
} from "../organisation/actionTypes";
import { getToken, modifyOrganisationsList } from "../../helper/common";
import agent from "../services/agent";
import { showSnackbarStatus } from "../snackbar/actions";
import { clearForm } from "../form/actions";
import trimmedValues from "../../helper/trimmer";
//   import { clearForm } from "./form.actions";
//   import { showSnackbarStatus } from "./snackbar.actions";

export const createOrganisationPending = () => ({
  type: CREATE_ORGANISATION_PENDING,
});

export const createOrganisationSuccess = () => ({
  type: CREATE_ORGANISATION_SUCCESS,
});

export const createOrganisationError = (errorMessage) => ({
  type: CREATE_ORGANISATION_ERROR,
  payload: { errorMessage },
});

export const OrgListError = (errorMessage) => ({
  type: ORGANISATION_LIST_ERROR,
  payload: { errorMessage },
});

export const clearCreateOrganisationError = () => ({
  type: CLEAR_ORGANISATION_ERROR,
});

export const setOrganisationFormInitialState = () => ({
  type: SET_INITIAL_STATE,
});

export const openCreateOrganisationModal = () => ({
  type: OPEN_CREATE_ORGANISATION_MODAL,
});

export const closeCreateOrganisationModal = () => ({
  type: CLOSE_CREATE_ORGANISATION_MODAL,
});

export const setOrganisationsPending = () => ({
  type: SET_ORGANISATIONS_PENDING,
});

export const setOrganisationsList = (organisationsOdata) => ({
  type: SET_ORGANISATIONS_LIST,
  payload: { organisationsOdata },
});

export const setPageSizeGlobal = (pageSize) => ({
  type: SET_PAGE_SIZE_GLOBAL,
  payload: { pageSize },
});

export const addOrg = (AddOrganisation) => ({
  type: ADD_ORG,
  payload: { AddOrganisation }
});

export const setOrganisationsListForAsyncSelect = (organisationsList, searchValue) => ({
  type: SET_ORGANISATIONS_LIST_ASYNC,
  payload: {
    organisationsListAsync: organisationsList,
    searchValueAsync: searchValue,
  },
});

export const createOrganisation = (organisation) => (dispatch, getState) => {
  const currentState = getState();
  const { pageSizeGlobal } = currentState && currentState.organisation;

  dispatch(createOrganisationPending());
  // dispatch(clearCreateOrganisationError());
  const values = trimmedValues(organisation)
  getToken(dispatch).then((accessToken) => {
    agent.Organisation.createOrganisation(accessToken, values)
      .then(() => {
        dispatch(createOrganisationSuccess());
        dispatch(closeCreateOrganisationModal());
        dispatch(getOrganisations(1, pageSizeGlobal));
        dispatch(clearForm());
        // dispatch(getOrganisations());
        dispatch(showSnackbarStatus("Organization created successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(createOrganisationError(message));
          // dispatch(clearForm());
          return;
        } else {
          const message = "Network error";
          dispatch(createOrganisationError(message));
        }
        console.log("Create organisation server error", err);
        // dispatch(clearForm());
        // dispatch(createOrganisationError(null));
        // dispatch(closeCreateOrganisationModal());
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};

export const getOrganisations = (page, pageSize, searchName, searchOrgType, searchUserCount, searchDeviceCount, searchAddress, searchActive, searchApproveNewCustomer, searchAllowCustomerSelfRegistration, searchEnableUserMailNotification, searchCreatedDateTime, sortDirection, sortOrder) => (dispatch) => {
  dispatch(setOrganisationsPending());
  getToken(dispatch).then((accessToken) => {
    agent.Organisation.getOrganisations(accessToken, page, pageSize, searchName, searchOrgType, searchUserCount, searchDeviceCount, searchAddress, searchActive, searchApproveNewCustomer, searchAllowCustomerSelfRegistration, searchEnableUserMailNotification, searchCreatedDateTime, sortDirection, sortOrder)
      .then((organisationsList) => {
        dispatch(setOrganisationsList(organisationsList));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(OrgListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(OrgListError(message));
        }
        console.log("getOrganizations server error", err);
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};

export const getUsersOrganisationsForAsyncSelect = (mfgFilter, searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.User.getOrganisations(accessToken, mfgFilter, searchValue)
      .then((organisationsList) => {
        let orglist = modifyOrganisationsList(organisationsList);
        dispatch(setOrganisationsListForAsyncSelect(orglist));
        callback && callback(orglist);
      })
      .catch((err) => {
        console.log("getOrganizations server error", err);
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
        callback && callback();
      });
  });
};

export const getOrganisationsForAsyncSelect = (searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.Device.getOrganisations(accessToken, searchValue)
      .then((organisationsList) => {
        let orglist = modifyOrganisationsList(organisationsList);
        dispatch(setOrganisationsListForAsyncSelect(orglist));
        callback && callback(orglist);
      })
      .catch((err) => {
        console.log("getOrganizations server error", err);
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
        callback && callback();
      });
  });
};
